import "./searchBar.scss";

// `clearable` (default true) draws the `×` that empties the field. Pass false only
// where the caller supplies its own reset in `children` — two controls side by side
// doing exactly the same thing is worse than either alone.
export default function SearchBar({
  value,
  onChange,
  placeholder = "Search",
  className = "",
  autoFocus = false,
  iconPosition = "right",
  clearable = true,
  onKeyDown,
  children,
}) {
  const showIcon = iconPosition !== "none";

  const icon = (
    <span className="searchbar-icon">
      <i className="material-icons">search</i>
    </span>
  );

  return (
    <div
      className={`searchbar-container ${showIcon ? "" : "no-icon"} ${className}`
        .replace(/\s+/g, " ")
        .trim()}
    >
      {showIcon && iconPosition === "left" && icon}
      <input
        type="text"
        className="searchbar-input"
        placeholder={placeholder}
        value={value ?? ""}
        autoFocus={autoFocus}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
      />
      {clearable && value && (
        <span className="searchbar-clear" onClick={() => onChange("")} title="Clear">
          ×
        </span>
      )}
      {children}
      {showIcon && iconPosition === "right" && icon}
    </div>
  );
}
